export default __webpack_public_path__ + "b2f7b7a87d9043b5f1b6b0a951d40bef.jpg";